export const QUERY_KEY_DATA_DASHBOARD = "get_new_dashboard_data";
